import { forwardRef } from "react";
import { MaskedInput, type MaskedInputProps } from "./MaskedInput";
import { maskCurrencyInput } from "../../lib/format";

export type CurrencyInputProps = Omit<MaskedInputProps, "mask">;

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  function CurrencyInput(props, ref) {
    return (
      <MaskedInput
        ref={ref}
        inputMode="decimal"
        autoComplete="off"
        placeholder="R$ 0,00"
        mask={maskCurrencyInput}
        {...props}
      />
    );
  }
);
